import { toast as sonnerToast } from "sonner";

/**
 * Custom toast function for backward compatibility with old toast API
 * Converts old toast object syntax to Sonner's API
 */
export function toast(options: {
	title?: string;
	description?: string;
	variant?: "default" | "destructive";
	action?: React.ReactNode;
}) {
	const { title, description, variant = "default", action } = options;

	// Combine title and description for better UX
	const message =
		title && description
			? `${title}: ${description}`
			: title || description || "";

	if (variant === "destructive") {
		return sonnerToast.error(message, {
			action,
		});
	}

	return sonnerToast.success(message, {
		action,
	});
}

// Re-export all Sonner functions for direct usage
// Note: promise is exported separately to avoid TS4023 error with sonner v2
export const success = sonnerToast.success;
export const error = sonnerToast.error;
export const info = sonnerToast.info;
export const warning = sonnerToast.warning;
export const loading = sonnerToast.loading;
export const custom = sonnerToast.custom;
export const dismiss = sonnerToast.dismiss;

// Export promise with explicit typing to avoid TS4023
export const promise = sonnerToast.promise as typeof sonnerToast.promise;
